import React from 'react'
import { PageTitle } from 'uiComponents/typography/pageElements'
import { ActionButtonA } from 'uiComponents/buttons'
import './redirectPage.scss'

interface RedirectPageProps {
    oldPageTitle: string
    newPageTitle: string
    action: string
    image: string
    link: string
}

const RedirectPage: React.FC<RedirectPageProps> = ({ oldPageTitle, newPageTitle, action, image, link }) => {
    return (
        <div className="redirect-page">
            <PageTitle>{oldPageTitle}</PageTitle>
            <div className="redirect-content">
                <img src={image} alt={oldPageTitle} />
                <span>
                    The {oldPageTitle} {action} the {newPageTitle}.
                </span>
                <ActionButtonA className="redirect-button" href={link}>
                    Visit the {newPageTitle}
                </ActionButtonA>
            </div>
        </div>
    )
}

export default RedirectPage
